export const types = {
  ADD_ARCHIVE_ITEMS: 'ADD_ARCHIVE_ITEMS',
  ACTIVATE_TEAM_MEMBER: 'ACTIVATE_TEAM_MEMBER',
  ACTIVATE_ARCHIVE_TEAM_MEMBER: 'ACTIVATE_ARCHIVE_TEAM_MEMBER',
  SET_TEAMMEMBERS: 'SET_TEAMMEMBERS',
  SET_TEAM_ITEMS: 'SET_TEAM_ITEMS',
  SET_TEAM_ITEMS_FOR_GROUP: 'SET_TEAM_ITEMS_FOR_GROUP',
  SET_ITEMS_LOADED: 'SET_ITEMS_LOADED'
}



// WEBPACK FOOTER //
// ./src/features/teamlist/store/types.js